import Article from 'models/Article';

import Component from './component';

export interface Props extends ParentProps { }

export interface LocalRatings {
    rating: number;
    id: string;
}

export interface ParentProps {
    article: Article;
    translations?: {
        rateTitle?: string;
        ratingTitle?: string;
        ratedTitle?: string;
        ratingsCountTitle?: string;
        noRating?: string;
    };
}

Component.defaultProps = {};
export default Component;
